import {
  CONFIRM_PAYMENT,
  NEW_PAYMENTS,
  NEW_PAYMENT,
  NEW_SINGLE_PAYMENT,
  NEW_PAYMENTS_FILTERS,
  NEW_LOADING_TABLE,
  NEW_SEARCHING,
  NEW_STATS_PAYMENTS,
  NEW_VALUES_PAYMENTS,
  SET_INVOICE_ERROR,
  CHANGE_PAYMENT_LOADING
} from '../actions/paymentActions';

import { RESET_ACCOUNT, LOG_OUT } from '../actions/accountActions';

const initialState = {
  confirm: null,
  page: null,
  filters_stats: {},
  payment: null,
  isLoading: false,
  activeFilters: [
    {
      label: 'Fecha pagos',
      filterKey: 'paid_at',
      type: 'date',
      filterCondition: 'btw',
      value: '',
      period: 'Todo'
    },
    {
      label: 'Buscar',
      filterKey: 'general',
      type: 'search',
      value: '',
      personalized: true
    },
    {
      label: 'Monto',
      filterKey: 'amount',
      type: 'amount',
      value: '',
      personalized: true
    },
    {
      label: 'Página',
      filterKey: 'page',
      type: 'page',
      value: 1,
      personalized: true
    },
    {
      label: 'Tabs',
      filterKey: 'status',
      type: 'tab',
      value: '', // => 'Todos'
      activeTab: '1',
      personalized: true
    },
    {
      label: 'Estado',
      filterKey: 'status',
      type: 'options',
      options: [
        { label: 'Aceptados', value: 'confirmed' },
        { label: 'Pendientes', value: 'pending' },
        { label: 'Rechazados', value: 'reject' },
        { label: 'Cancelados', value: 'cancel' }
      ],
      value: 'confirmed,pending',
      personalized: true
    }
  ],
  updateTable: true,
  searching: false,
  loadingTable: false,
  initialValuesTags: {
    Estado: {
      confirmed: false,
      pending: false,
      reject: false,
      cancel: false
    },
    Manual: {
      ar: false,
      xml: false,
      bar: false
    },
    Pasarela: {
      fiserv: false,
      oxxo_public: false,
      stp: false,
      stripe: false,
      conekta: false,
      spei: false,
      kushki: false,
      payfac: false,
      bank_sync: false
    },
    Comprobante: {
      1: false,
      2: false,
      3: false
    }
  },
  errors: {
    cfdiError: ''
  }
}; // END initialState

export default function (state = initialState, action) {
  let { payload } = action,
    newState;
  switch (action.type) {
    case CONFIRM_PAYMENT:
      newState = { confirm: payload };
      return { ...state, ...newState };

    case NEW_PAYMENTS:
      newState = { page: payload };
      return { ...state, ...newState };
    case NEW_STATS_PAYMENTS:
      newState = { filters_stats: payload || [] };
      return { ...state, ...newState };

    case NEW_PAYMENT:
      newState = { payment: payload };
      return { ...state, ...newState };

    case NEW_SINGLE_PAYMENT:
      newState = { payment: payload };
      return { ...state, ...newState };

    case NEW_PAYMENTS_FILTERS:
      newState = { activeFilters: payload.filters, updateTable: payload.updateTable, searching: payload.searching };
      return { ...state, ...newState };

    case NEW_VALUES_PAYMENTS:
      newState = {
        initialValuesTags: payload
      };
      return { ...state, ...newState };

    case NEW_LOADING_TABLE:
      newState = { loadingTable: payload };
      return { ...state, ...newState };

    case NEW_SEARCHING:
      newState = { searching: payload };
      return { ...state, ...newState };

    case RESET_ACCOUNT:
    case LOG_OUT:
      newState = { initialState };
      return { ...state, ...initialState };
    case SET_INVOICE_ERROR:
      return {
        ...state,
        errors: {
          cfdiError: action.payload.data
        }
      };
    case CHANGE_PAYMENT_LOADING:
      return {
        ...state,
        isLoading: action.payload.data
      };

    default:
      return state;
  } // END switch
} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/paymentReducer.js